import { withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    onMousedown: _ctx.clickMouseDetectionComponent,
    onTouchstart: _ctx.clickMouseDetectionComponent,
    onTouchend: _ctx.emitMouseUp,
    onTouchmove: _ctx.emitTouchTracking,
    onMouseover: _ctx.hoverMouseDetectionComponent,
    onContextmenu: _withModifiers(_ctx.rightClickDetectionComponent, ["prevent"]),
    style: _normalizeStyle(`grid-area: ${_ctx.y}/${_ctx.x}/${_ctx.y+1}/${_ctx.x+1}`)
  }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */, ["onMousedown", "onTouchstart", "onTouchend", "onTouchmove", "onMouseover", "onContextmenu"]))
}